import styled from "styled-components";

const PageContainer = styled.div`
  position: relative;
  width: calc(100% - 48px);
  max-width: 1360px;
  min-width: 320px;
  margin: auto;
  padding-top: 0;
  padding-left: 24px;
  padding-right: 24px;

  @media only screen and (max-width: 896px) {
    width: calc(100% - 160px);
    padding-left: 80px;
    padding-right: 80px;
  }

  @media only screen and (max-width: 512px) {
    width: calc(100% - 48px);
    padding-left: 24px;
    padding-right: 24px;
  }
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: 896px) {
    flex-direction: column;
  }
`;

const ReversedSectionContainer = styled(SectionContainer)`
  flex-direction: row-reverse;

  @media only screen and (max-width: 896px) {
    flex-direction: column;
  }
`;

const SectionItem = styled.div`
  flex: 1;
  width: 0;
  display: flex;
  padding-top: 0;
  padding-bottom: 0;
  flex-direction: column;
  justify-content: center;
  height: 800px;

  @media only screen and (max-width: 896px) {
    padding-top: 24px;
    padding-bottom: 24px;
    flex-grow: 1;
    width: 100%;
    height: auto;
    min-height: auto;
  }
`;

const SectionSpacer = styled.div`
  width: 80px;
  height: 100%;

  @media only screen and (max-width: 896px) {
    width: 0;
    height: 0;
  }
`;

const SectionGroup = styled.div`
  margin-left: 40px;
  margin-right: 120px;

  @media only screen and (max-width: 1152px) {
    margin-right: 40px;
  }

  @media only screen and (max-width: 896px) {
    margin-left: 0;
    margin-right: 40px;
  }

  @media only screen and (max-width: 512px) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export { PageContainer, SectionContainer, ReversedSectionContainer, SectionSpacer, SectionItem, SectionGroup } ;